// src/components/LoadingFallback.jsx
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * LoadingFallback - Componente de carga para Suspense
 * Se muestra mientras React.lazy() está cargando componentes
 */
const LoadingFallback = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
                gap: 2,
            }}
        >
            <CircularProgress
                size={60}
                thickness={4}
                sx={{
                    color: '#E50914',
                    '& .MuiCircularProgress-circle': {
                        strokeLinecap: 'round',
                    }
                }}
            />
            <Typography
                variant="body1"
                sx={{
                    color: '#666',
                    fontWeight: 500,
                    animation: 'pulse 1.5s ease-in-out infinite',
                    '@keyframes pulse': {
                        '0%, 100%': { opacity: 0.6 },
                        '50%': { opacity: 1 },
                    }
                }}
            >
                Cargando...
            </Typography>
        </Box>
    );
};

export default LoadingFallback;
